import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetAllSchools = async () => {
  try {
    const SchoolsCollection = collection(db, "Schools");

    const q = query(SchoolsCollection, where("IsDeleted", "==", false));
    const SchoolsSnapshot = await getDocs(q);

    let SchoolsData = [];

    SchoolsSnapshot.forEach((doc) => {
      SchoolsData.push({ label: doc.data().SchoolName, value: doc.id });
    });
    return SchoolsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllSchools;
